import axios from 'axios'

const getHeaders = () => {
  return {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      'Content-Type': 'application/json',
    },
  }
}

const handleRequest = async (request) => {
  try {
    const response = await request()
    return response.data
  } catch (error) {
    console.error('API request failed:', error)
    throw error
  }
}

// * Lab Information service

export const getAllLabGroupInfo = async () => {
  return handleRequest(() =>
    axios.get(`${import.meta.env.VITE_LABINFO_API_URL}/api/v2/labInfo/lab-groups`, getHeaders())
  )
}

export const getSpecificLabGroupModules = async (slug) => {
  return handleRequest(() =>
    axios.get(
      `${import.meta.env.VITE_LABINFO_API_URL}/api/v2/labInfo/lab-group/${slug}`,
      getHeaders()
    )
  )
}

export const getSpecificModuleInfo = async (slug) => {
  return handleRequest(() =>
    axios.get(`${import.meta.env.VITE_LABINFO_API_URL}/api/v2/labInfo/module/${slug}`, getHeaders())
  )
}

export const getSpecificLabGroupInfo = async (id) => {
  return handleRequest(() =>
    axios.get(`${import.meta.env.VITE_LABINFO_API_URL}/api/v1/labInfo/get_info/${id}`, getHeaders())
  )
}

export const getSpecificLabInfo = async (labID) => {
  return handleRequest(() =>
    axios.get(`${import.meta.env.VITE_LABINFO_API_URL}/api/v2/labInfo/lab/${labID}`, getHeaders())
  )
}

export const enrollLab = async (payload) => {
  return handleRequest(() =>
    axios.post(
      `${import.meta.env.VITE_LABINFO_API_URL}/api/v1/labInfo/enroll`,
      payload,
      getHeaders()
    )
  )
}

export const checkLabEnrollment = async (id) => {
  return handleRequest(() =>
    axios.get(`${import.meta.env.VITE_LABINFO_API_URL}/api/v1/labInfo/enrolled/${id}`, getHeaders())
  )
}

export const addSpecificLabCount = async (id) => {
  return handleRequest(() =>
    axios.get(
      `${import.meta.env.VITE_LABINFO_API_URL}/api/v1/labInfo/lab/counter/${id}`,
      getHeaders()
    )
  )
}

export const getSpecificLabCount = async (id) => {
  return handleRequest(() =>
    axios.get(
      `${import.meta.env.VITE_LABINFO_API_URL}/api/v1/labInfo/lab/user/get_counter/${id}`,
      getHeaders()
    )
  )
}
